var _ellipse, _g, _g2, _g3, _path, _path2, _rect, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 164,
    height: 114,
    viewBox: "0 0 164 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.05,
    cx: 78.076,
    cy: 49.7488,
    rx: 78.076,
    ry: 49.7488,
    transform: "matrix(-0.915086 -0.403258 -0.403298 0.915069 173.52 43.4695)",
    fill: "#72A4FC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2437_2975)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.5,
    y: 19.5,
    width: 116,
    height: 24.1,
    rx: 4,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.75,
    y: 19.75,
    width: 115.5,
    height: 23.6,
    rx: 3.75,
    stroke: "#F2F2F2",
    strokeWidth: 0.5,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.5,
    y: 25.5,
    width: 12.1,
    height: 12.1,
    rx: 6.05,
    fill: "#D2D2D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.5996 30.05C65.5996 29.4978 65.1519 29.05 64.5996 29.05H49.5996C49.0473 29.05 48.5996 29.4978 48.5996 30.05V33.05C48.5996 33.6023 49.0473 34.05 49.5996 34.05H64.5996C65.1519 34.05 65.5996 33.6023 65.5996 33.05V30.05Z",
    fill: "#CECECE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.6 30.05C107.6 29.4978 107.152 29.05 106.6 29.05H70.5996C70.0473 29.05 69.5996 29.4978 69.5996 30.05V33.05C69.5996 33.6023 70.0473 34.05 70.5996 34.05H106.6C107.152 34.05 107.6 33.6023 107.6 33.05V30.05Z",
    fill: "#CECECE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.6 30.05C122.6 29.4978 122.152 29.05 121.6 29.05H112.6C112.047 29.05 111.6 29.4978 111.6 30.05V33.05C111.6 33.6023 112.047 34.05 112.6 34.05H121.6C122.152 34.05 122.6 33.6023 122.6 33.05V30.05Z",
    fill: "#CECECE"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_2437_2975)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.5,
    y: 47.6,
    width: 116,
    height: 24.1,
    rx: 4,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.75,
    y: 47.85,
    width: 115.5,
    height: 23.6,
    rx: 3.75,
    stroke: "#F2F2F2",
    strokeWidth: 0.5,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.5,
    y: 53.6,
    width: 12.1,
    height: 12.1,
    rx: 6.05,
    fill: "#D2D2D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.5996 58.15C77.5996 57.5977 77.1519 57.15 76.5996 57.15H49.5996C49.0473 57.15 48.5996 57.5977 48.5996 58.15V61.15C48.5996 61.7023 49.0473 62.15 49.5996 62.15H76.5996C77.1519 62.15 77.5996 61.7023 77.5996 61.15V58.15Z",
    fill: "#CECECE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.5996 58.15C93.5996 57.5977 93.1519 57.15 92.5996 57.15H82.5996C82.0473 57.15 81.5996 57.5977 81.5996 58.15V61.15C81.5996 61.7023 82.0473 62.15 82.5996 62.15H92.5996C93.1519 62.15 93.5996 61.7023 93.5996 61.15V58.15Z",
    fill: "#CECECE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.6 58.15C114.6 57.5977 114.152 57.15 113.6 57.15H98.5996C98.0473 57.15 97.5996 57.5977 97.5996 58.15V61.15C97.5996 61.7023 98.0473 62.15 98.5996 62.15H113.6C114.152 62.15 114.6 61.7023 114.6 61.15V58.15Z",
    fill: "#CECECE"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_2437_2975)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.5,
    y: 75.7,
    width: 116,
    height: 24.1,
    rx: 4,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.75,
    y: 75.95,
    width: 115.5,
    height: 23.6,
    rx: 3.75,
    stroke: "#F2F2F2",
    strokeWidth: 0.5,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.5,
    y: 81.7,
    width: 12.1,
    height: 12.1,
    rx: 6.05,
    fill: "#D2D2D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.5996 86.25C66.5996 85.6977 66.1519 85.25 65.5996 85.25H49.5996C49.0473 85.25 48.5996 85.6977 48.5996 86.25V89.25C48.5996 89.8023 49.0473 90.25 49.5996 90.25H65.5996C66.1519 90.25 66.5996 89.8023 66.5996 89.25V86.25Z",
    fill: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.5996 86.25C99.5996 85.6977 99.1519 85.25 98.5996 85.25H71.5996C71.0473 85.25 70.5996 85.6977 70.5996 86.25V89.25C70.5996 89.8023 71.0473 90.25 71.5996 90.25H98.5996C99.1519 90.25 99.5996 89.8023 99.5996 89.25V86.25Z",
    fill: "#E7E7E7"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M133.564 86.3571L131.961 86.8116C129.747 87.4392 127.443 86.1531 126.816 83.9392C126.188 81.7252 127.474 79.4217 129.688 78.7942L131.292 78.3396M138.375 84.9936L139.978 84.5391C142.192 83.9116 143.478 81.6081 142.851 79.3941C142.223 77.1801 139.92 75.8941 137.706 76.5216L136.102 76.9761M130.825 82.8029L138.842 80.5304",
    stroke: "#C4D9FE",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6351 20.8816L27.4101 19.9511C24.338 18.6664 22.8891 15.1345 24.1738 12.0625C25.4585 8.9904 28.9904 7.54148 32.0625 8.8262L34.2875 9.75668M36.31 23.6731L38.535 24.6036C41.6071 25.8883 45.139 24.4393 46.4237 21.3673C47.7084 18.2952 46.2595 14.7633 43.1874 13.4786L40.9624 12.5481M29.7363 14.3887L40.8612 19.0411",
    stroke: "#C4D9FE",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 52.5,
    y: 27.5,
    width: 60,
    height: 60,
    rx: 30,
    fill: "#FF3636"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M73.5 48.5L82.5 57.5M91.5 66.5L82.5 57.5M82.5 57.5L91.5 48.5M82.5 57.5L73.5 66.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2437_2975",
    x: 20.5,
    y: 19.5,
    width: 124,
    height: 32.1,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.720833 0 0 0 0 0.720833 0 0 0 0 0.720833 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2437_2975"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2437_2975",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_2437_2975",
    x: 20.5,
    y: 47.6,
    width: 124,
    height: 32.1,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.720833 0 0 0 0 0.720833 0 0 0 0 0.720833 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2437_2975"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2437_2975",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_2437_2975",
    x: 20.5,
    y: 75.7,
    width: 124,
    height: 32.1,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.720833 0 0 0 0 0.720833 0 0 0 0 0.720833 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2437_2975"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2437_2975",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.0e5c41d2.svg";
export { ForwardRef as ReactComponent };